export default class NavigationMenuDesktop {
  constructor(component) {
    this.dom = {
      $component: component,
      $navigation: document.querySelector('.js-navigation'),
      $mainLinks: component.querySelectorAll('.js-navigationMenuDesktopLink[data-sublinks]'),
      $drawer: component.querySelector('.js-navDrawer'),
      $drawerUnderlay: document.querySelector('.js-navDrawerUnderlay')
    }
    this.state = {
      drawerOpen: false,
      drawerOpenDelay: null,
      drawerHover: false,
      linkHover: false,
      activeDrawerNav: '',
      openDrawerClass: 'openDrawer',
      activeDrawerNavClass: 'active',
      underlayActiveClass: 'isActive',
      navMenuLinkClass: '.js-navigationMenuDesktopLink',
      drawerSubMenuClass: '.js-navSubContainerDesktop'
    }
    this.mainLinkEnterHandler = this.mainLinkEnter.bind(this)
    this.mainLinkLeaveHandler = this.mainLinkLeave.bind(this)
    this.drawerEnterHandler = this.drawerEnter.bind(this)
    this.drawerLeaveHandler = this.drawerLeave.bind(this)
    this.mainLinkKeyDownHandler = this.mainLinkKeyDown.bind(this)
    this.escapePressHandler = this.escapePress.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {dom} = this
    dom.$mainLinks.forEach($link => $link.addEventListener('mouseenter', this.mainLinkEnterHandler))
    dom.$mainLinks.forEach($link => $link.addEventListener('mouseleave', this.mainLinkLeaveHandler))
    dom.$mainLinks.forEach($link => $link.addEventListener('keydown', this.mainLinkKeyDownHandler))
    dom.$drawer.addEventListener('mouseenter', this.drawerEnterHandler)
    dom.$drawer.addEventListener('mouseleave', this.drawerLeaveHandler)
    window.addEventListener('keydown', this.escapePressHandler)
  }

  mainLinkEnter(e) {
    const {state} = this
    state.linkHover = true
    const subNavUrl = e.currentTarget.dataset.sublinks

    if (state.drawerOpenDelay) {
      clearTimeout(state.drawerOpenDelay)
      state.drawerOpenDelay = null
    }

    this.clearSubNav()

    if (!state.drawerOpen) {
      state.drawerOpenDelay = setTimeout(async () => {
        this.openDrawer()
        await new Promise(resolve => setTimeout(resolve, 500))

        if (subNavUrl === state.activeDrawerNav || state.activeDrawerNav === '') {
          this.setSubNav(subNavUrl)
        }

        state.drawerOpenDelay = null
      }, 500)
      return
    }

    this.setSubNav(subNavUrl)
  }

  setSubNav(url) {
    const {dom, state} = this
    const subNavClass = `${state.drawerSubMenuClass}[data-sublinks="${url}"]`
    const activeLink = `${state.navMenuLinkClass}[data-sublinks="${url}"]`
    dom.$component.querySelector(subNavClass).classList.add(state.activeDrawerNavClass)
    dom.$component.querySelector(activeLink).classList.add(state.activeDrawerNavClass)
    state.activeDrawerNav = url
  }

  clearSubNav() {
    const {dom, state} = this
    if (!state.activeDrawerNav) return
    const currentActiveNavClass = `${state.drawerSubMenuClass}[data-sublinks="${state.activeDrawerNav}"]`
    const currentActiveLink = `${state.navMenuLinkClass}[data-sublinks="${state.activeDrawerNav}"]`
    dom.$component.querySelector(currentActiveNavClass).classList.remove(state.activeDrawerNavClass)
    dom.$component.querySelector(currentActiveLink).classList.remove(state.activeDrawerNavClass)
    state.activeDrawerNav = ''
  }

  async mainLinkLeave() {
    const {state} = this
    state.linkHover = false

    await new Promise(resolve => setTimeout(resolve, 0))
    if (state.drawerHover || state.linkHover) return

    if (state.drawerOpenDelay) {
      clearTimeout(state.drawerOpenDelay)
      state.drawerOpenDelay = null
    }

    this.closeDrawer()
  }

  drawerEnter() {
    const {state} = this
    state.drawerHover = true
  }

  async drawerLeave() {
    const {state} = this
    state.drawerHover = false

    await new Promise(resolve => setTimeout(resolve, 0))
    if (state.linkHover) return

    this.closeDrawer()
  }

  openDrawer() {
    const {dom, state} = this
    dom.$drawer.classList.add(state.openDrawerClass)
    dom.$navigation.classList.add(state.openDrawerClass)
    dom.$drawerUnderlay.classList.add(state.underlayActiveClass)
    state.drawerOpen = true
  }

  closeDrawer() {
    const {dom, state} = this
    dom.$drawer.classList.remove(state.openDrawerClass)
    dom.$drawerUnderlay.classList.remove(state.underlayActiveClass)
    setTimeout(() => {
      dom.$navigation.classList.remove(state.openDrawerClass)
    }, 500)
    state.drawerOpen = false
    this.clearSubNav()
  }

  mainLinkKeyDown(e) {
    if (e.keyCode !== 13) return
    this.mainLinkEnter(e)
  }

  escapePress(e) {
    if (e.keyCode !== 27) return
    this.mainLinkLeave()
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.NavigationMenuDesktop = this
  }
}

